import { render, staticRenderFns } from "./VAppLayout.vue?vue&type=template&id=6617a24a&"
import script from "./VAppLayout.vue?vue&type=script&lang=ts&"
export * from "./VAppLayout.vue?vue&type=script&lang=ts&"
import style0 from "./VAppLayout.vue?vue&type=style&index=0&id=6617a24a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports